import InnerBanner from "../Components/InnerBanner/InnerBanner";
import Accordion from "../Components/Accordion/Accordion";

function Faqs() {
    return (
        <>
            <InnerBanner
                img_url='faqBanner.webp'
                heading={['Frequently asked ', <br/>, 'questions']}
            />
            <section className="faqSec">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <Accordion
                                data={[
                                    {
                                        'head': 'How long does the program last, and what is the class schedule?',
                                        'content': 'At Skill Bridge we\'ve carefully designed our programs to provide a comprehensive learning experience that covers all essential DevOps concepts and practices. With a duration of 16 weeks, our courses offer a balanced and in-depth exploration of the field. The class schedule varies depending on the program type – whether it\'s online, remote, or on-site. Our flexible scheduling ensures that you can choose a class time that suits your lifestyle and commitments, making it accessible for learners with diverse schedules.'
                                    },
                                    {
                                        'head': 'What do I need in order to take part in the remote course?',
                                        'content': 'Remote learning has never been easier with Skill Bridge. We prioritise your convenience by offering online courses that you can access from the comfort of your own space. All you need is a stable internet connection and a device (laptop or PC) to access our virtual classrooms. No additional equipment is required. Our user-friendly platforms ensure that you can engage in learning without any technical hurdles, allowing you to focus on gaining valuable DevOps skills.'
                                    },
                                    {
                                        'head': 'How does the program prepare students for real-world DevOps roles?',
                                        'content': 'Skill Bridge stands out by offering a practical, real-world learning experience right from the start. Our curriculum is carefully designed to include hands-on projects and scenarios that mimic real-life DevOps challenges. By applying the latest industry technologies and tools, you\'ll gain the skills and confidence needed to excel in actual DevOps roles. Our instructors, who are seasoned professionals in the field, provide expert guidance and insights to prepare you for the demands of the industry.'
                                    },
                                    {
                                        'head': 'Are there any specific prerequisite requirements or qualifications?',
                                        'content': 'We believe in inclusivity and providing opportunities for learners of all backgrounds. That\'s why our programs do not have specific prerequisite requirements or qualifications. While having some basic knowledge of DevOps concepts can be helpful, it is by no means mandatory. What matters most is your passion for learning and your determination to succeed. We\'re here to support you every step of the way, regardless of your prior experience.'
                                    },
                                    {
                                        'head': 'Are there opportunities for internships or job placements?',
                                        'content': 'At Skill Bridge we understand the importance of practical experience in your journey to becoming a DevOps professional. That\'s why we provide internship and work experience opportunities as part of our program. During your training, you\'ll have the chance to gain valuable industry exposure and hands-on practice. Additionally, we assist you in finding job placements after completing the program, connecting you with our extensive network of partner organisations actively seeking skilled DevOps engineers. Your success is our priority, and we\'re dedicated to helping you launch your career in the tech industry.'
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section className="contactSec">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="contactImg">
                                <figure>
                                    <img src={process.env.PUBLIC_URL + '/images/faqMain.webp'} alt=""/>
                                </figure>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="contactForm faq">
                                <div className="head">
                                    <h5 className="tag">
                                        education for everyone
                                    </h5>
                                    <h3>
                                        Get a Free Course You Can Contact With Me
                                    </h3>
                                </div>
                                <form action="">
                                    <input type="text" placeholder="Name"/>
                                    <input type="email" placeholder="Email"/>
                                    <input type="tel" placeholder="Phone"/>
                                    <textarea name="" id="" rows="7" placeholder="Message"/>
                                    <button className="themeBtn">Submit</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Faqs